import { useChangelogApi, useChangelogStore } from '@entities/changelog'
import { useOnTimezoneChange } from '@entities/viewer'

interface DisciplineChangelogReturn {
  refIsFirstLoad: ComputedRef<boolean>
}

/** The discipline's changelog on the shared changelog store: its first read shares the page loader with the
 *  discipline, and the rows are dropped on leaving so no other changelog shows them. */
export const useDisciplineChangelog = (): DisciplineChangelogReturn => {
  const store = useChangelogStore()

  const refIsFirstLoad = computed<boolean>(() => store.isLoading && store.getMeta === null)

  onMounted(() => {
    void useChangelogApi()
  })

  // Row times arrive pre-shifted into the admin's view timezone.
  useOnTimezoneChange(() => {
    void useChangelogApi()
  })

  onBeforeUnmount(() => {
    store.resetList()
  })

  return {
    refIsFirstLoad,
  }
}
